export const TemplateTypes = [
  { id: 'standard', name: 'Standard' },
  { id: 'media', name: 'Media' },
  { id: 'bespoke', name: 'Bespoke' }
];

export const VARIANT_FIELDS = {
  production: {
    dirField: 'editorDirectory',
    fileField: 'templateFile',
    s3Field: 'file',
    configField: 'defaultConfig'
  },
  beta: {
    dirField: 'betaEditorDirectory',
    fileField: 'betaTemplateFile',
    s3Field: 'betaFile',
    configField: 'betaDefaultConfig'
  }
};
